import { useEffect } from 'react';
import { useAppDispatch } from '@/store';
import { getCategories } from '@/modules/Categories';
import { CategoryMultiTreeSelect } from '@/modules/SharedCategories/components';
import { useCategoriesSelect } from '@/modules/SharedCategories/hooks';

type TCategoryIdsField = {
  value?: string[];
  onChange: (v: string[]) => void;
  label?: string;
};

const CategoryIdsField = ({ value, onChange, label }: TCategoryIdsField) => {
  const dispatch = useAppDispatch();
  const { categories, autocompleteCategories, onSearch, expandedItems, handleExpandTreeItemData } =
    useCategoriesSelect(undefined);

  useEffect(() => {
    dispatch(getCategories());
  }, [dispatch]);

  return (
    <CategoryMultiTreeSelect
      label={label}
      value={value}
      onChange={onChange}
      categories={categories}
      autocompleteCategories={autocompleteCategories}
      onSearch={onSearch}
      expandedItems={expandedItems}
      handleExpandTreeItemData={handleExpandTreeItemData}
      disableInactive
    />
  );
};

export default CategoryIdsField;
